<template>
  <div id="app">
    <div id="nav">
      <router-link to="/"><Header /></router-link>
    </div>
    <router-view class="router-main" />
    <div id="footer" v-if="$route.name === 'Landing'">
      <router-link to="/about">About</router-link>
      |
      <router-link to="/recent">Recent</router-link>
      <br />
      <router-link to="/terms">Terms of Use</router-link>
      |
      <router-link to="/privacy">Privacy</router-link>
      |
      <router-link to="/disclaimer">Disclaimer</router-link>
      |
      <router-link to="/contact">Contact</router-link>
    </div>
    <div id="footer" v-else-if="$route.name === 'About'">
      <router-link to="/">Home</router-link>
      |
      <router-link to="/recent">Recent</router-link>

      <br />
      <router-link to="/terms">Terms of Use</router-link>
      |
      <router-link to="/privacy">Privacy</router-link>
      |
      <router-link to="/disclaimer">Disclaimer</router-link>
      |
      <router-link to="/contact">Contact</router-link>
    </div>
    <div id="footer" v-else-if="$route.name === 'Recent'">
      <router-link to="/about">About</router-link>
      |
      <router-link to="/">Home</router-link>
      <br />
      <router-link to="/terms">Terms of Use</router-link>
      |
      <router-link to="/privacy">Privacy</router-link>
      |
      <router-link to="/disclaimer">Disclaimer</router-link>
      |
      <router-link to="/contact">Contact</router-link>
    </div>
    <div id="footer" v-else-if="$route.name === 'Translate'">
      <router-link to="/about">About</router-link>
      |
      <router-link to="/recent">Recent</router-link>
      |
      <router-link to="/">Home</router-link>
      <br />
      <router-link to="/terms">Terms of Use</router-link>
      |
      <router-link to="/privacy">Privacy</router-link>
      |
      <router-link to="/disclaimer">Disclaimer</router-link>
      |
      <router-link to="/contact">Contact</router-link>
    </div>
  </div>
</template>
<script>
import Header from "./views/Header.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Header
  },
  created() {},
  computed: {
    ...mapGetters(["getToken"]),
    tokenStatus() {
      return this.getToken;
    }
  },
  beforeEach(to, from, next) {
    console.log(to, from, next);
    console.log("before");
  }
};
</script>
<style lang="sass">
body, html
  padding: 0
  margin: 0
  height: 100%
  width: 100%

#app
  font-family: Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  color: #000000
  background-color: #ffffff
  display: grid
  grid-template-columns: auto
  grid-template-rows: 75px auto
  grid-template-areas: "nav" "body" "footer"
  overflow: auto
  height: 100%
  width: 100%

#nav
  padding: 0px
  grid-area: nav
  height: 75px

.header
  height: 100%
  padding-top: 5px
  background-color: #ffffff

a
    font-weight: bold
    color: #000000
    underline-text: none

.router-main
  padding: 0px 5px 0px 5px
  background-color: #ffffff

button
  width: 130px
  background-color: #fed188
  color: #000000
  border: 0
  box-shadow: none
  border-radius: 0px
  padding: 5px
  margin-left: 5px

body

.buttonStd


.container
  grid-area: body
  display: grid
  height: 100%
  width 100%
  grid-template-columns: auto
  grid-template-rows: auto
  grid-template-areas: "leftcol section section section section rightcol" "leftcol section1 section1 section1 section1 rightcol" "leftcol section2 section2 section2 section2 rightcol" "leftcol section3 section3 section3 section3 rightcol"
  overflow: auto

.section
  grid-area: section
  max-height: 300px
  width: 100%
  height: auto
  overflow-y: scroll

.section1
  display:flex
  grid-area: section1
  height: auto
  overflow-y: scroll
  width: 100%


.section2
  display:flex
  grid-area: section2
  grid-row-start: 3
  grid-row-end: 4
  height: auto
  overflow-y: scroll
  width: 100%

.section3
  grid-area: section3
  grid-row-start: 4
  grid-row-end: 5
  height: auto
  width: 100%
  padding-bottom: 5px
  overflow-y: scroll

#footer
  grid-area: footer
  text-align: center
  margin: 0px 5px 0px 5px
  grid-row-start: 3
  grid-row-end: 4
  padding: 0px 5px 0px 5px
  background-color: #ffffff
  line-height: 50px
  align-items: bottom

h3
  margin: 0
  padding-left: 5px

p
  padding-left: 5px
  padding-bottom: 3px

.logo
  font-size: 25px

.right
  grid-area: rightcol
  width: 100%

.left
  grid-area: leftcol
  width: 100%

.floatLeft
  float: left
  padding-left: 5px
  padding-bottom: 0px

.floatRight
  font: outline
  float: right
  padding-right: 5px

.openSection
  color: grey
  font-size: 16px
  font-weight: bold
  text-align: center


.closedSection
  color: grey
  font-size: 20px
  font-weight: bold
  text-align: center
</style>
